import FinancialTableRowContainer from './FinancialTableRowContainer';

export default FinancialTableRowContainer;
